/**
 * The upload engine the Deal Room uses: straight to storage when that is on
 * (`REACT_APP_DIRECT_UPLOADS_ENABLED`), else through the backend. Both share
 * one contract, so the upload manager does not know which ran.
 */
import { runDirectUploadJob } from "./directUploadEngine";
import { isDirectUploadsEnabled } from "./featureFlags";
import { runUploadJob, UploadJobRequest, UploadResponse } from "./uploadEngine";

export const runDealRoomUploadJob = (
	request: UploadJobRequest
): Promise<UploadResponse> =>
	isDirectUploadsEnabled() ? runDirectUploadJob(request) : runUploadJob(request);
